import { FC } from "react";
import { useTranslation } from "react-i18next";
import Button from "Components/UI/Button";
import Modal from "Components/UI/Modal";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import {
  BtnContainer,
  Container,
  Content,
  Title,
} from "./styles";
import { Icon } from "Components/UI";

interface IDeleteModal {
  visible: boolean;
  loading?: boolean;
  name: string;
  stageId: number;
  isDefault?: boolean;
  onConfirm: (stageId: number) => void;
  onCancel: () => void;
}

const DeleteModal: FC<IDeleteModal> = ({
  visible,
  loading,
  name,
  stageId,
  isDefault,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation('editObra');

  return (
    <Modal
      visible={visible}
      width={450}
      footerButtons={null}
    >
      <Container>
        <Title>
          <span className="textTitle">
            {t('stagesPage.deleteTitle', { name })}
          </span>
        </Title>

        <Content isdefault={isDefault}>
          <span className="contentText">
            {isDefault
              ? t('stagesPage.deleteDefaultText')
              : t('stagesPage.deleteText')
            }
          </span>
          <span className="warningBox">
            <Icon
              icon={isDefault ? 'informacao' : 'alerta'}
              customSize={16}
              className="alertIcon"
            />
            <span className="alertText">
              {isDefault
                ? t('stagesPage.deleteDefaultHint')
                : t('stagesPage.deletePermanentWarning')
              }
            </span>
          </span>
        </Content>

        <BtnContainer>
          <Button type="text" onClick={onCancel}>
            {isDefault ? t('common.close') : t('common.cancel')}
          </Button>
          {!isDefault && (
            <Button
              type="primary"
              className="deleteBtn"
              onClick={() => onConfirm(stageId)}
              primaryDanger
            >
              {loading && (
                <Spin
                  indicator={
                    <LoadingOutlined
                      color="white"
                      style={{ fontSize: 12, color: 'white', marginRight: 6 }}
                    />
                  }
                />
              )}
              {loading ? t('common.deleting') : t('common.delete')}
            </Button>
          )}
        </BtnContainer>
      </Container>
    </Modal>
  )
}

export default DeleteModal;
